<template>
  <div class="flex items-center justify-center flex-col w-full h-full p-10">
    <aw-icon 
      icon="loading" 
      class="animate-spin w-14 h-14 text-bc-blue"
    />
    <p class="mt-2 text-gray-400">
      {{ $t('Loading') }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
  },
}
</script>

<style lang="scss" scoped>
</style>
